import './deferred-loading';
import 'jquery';
import { queryAll } from './utils/utils';
import { tns } from 'tiny-slider/src/tiny-slider.module';
import './actualite';

const $ = jQuery;

window.jQuery = jQuery;

const checkIfScrolled = () => {
  if ($(window).scrollTop() !== 0) {
    $(document.body).addClass('scrolled');
  }
  else {
    $(document.body).removeClass('scrolled');
  }
};

$(window).scroll(checkIfScrolled);
$(document).ready(checkIfScrolled);

queryAll('[data-slider]').forEach((sliderElm, index) => {
  if (!sliderElm.getAttribute('id')) {
    sliderElm.setAttribute('id', `tiny-slider-n-${index}`);
  }
  const displayControls
    = sliderElm.getAttribute('data-slider-controls') === 'false' ? false : true;

  const displayStartStop
    = sliderElm.getAttribute('data-slider-start-stop') === 'true' ? true : false;

  console.log(sliderElm.querySelector('[data-slider-controls-container]'));
  tns({
    container: `#${sliderElm.getAttribute('id')} [data-slider-container]`,
    items: 1,
    slideBy: 'page',
    controls: displayControls,
    autoplayButtonOutput: displayStartStop,
    nav: displayControls,
    navContainer: sliderElm.querySelector(
      '[data-slider-controls-nav-container]'
    ),
    controlsContainer: sliderElm.querySelector(
      '[data-slider-controls-container]'
    ),
    freezable: displayControls,
    lazyLoad: true,
    autoplay: true
  });
});



// WEBPACK FOOTER //
// ../work/src/js/body.js